import { TopNav } from './components/organisms/TopNav'
import { QuestionsSection } from './components/organisms/QuestionsSection'
import { BrandsSection } from './components/organisms/BrandsSection'
import { ServicesSection } from './components/organisms/ServicesSection'
import { CaseStudiesSection } from './components/organisms/CaseStudiesSection'
import { ProcessesSection } from './components/organisms/ProcessesSection'
import { BottomNav } from './components/organisms/BottomNav'

function App() {
  return (
    <div className="page">
      <TopNav />
      <QuestionsSection />
      <BrandsSection id="brands" />
      <ServicesSection id="services" />
      <CaseStudiesSection id="work" />
      <ProcessesSection id="process" />
      <BottomNav />
    </div>
  )
}

export default App
